const $ = jQuery.noConflict()

export default function hideIfOneSlide(slider) {
    if ($(slider + ' .slick-track').children().length === 1) {
        $(slider + ' .slick-arrow').hide()
    }
}
